var map = {
  "./critical.png": "84362",
  "./guestadom_idx.png": "13810",
  "./high.png": "32098",
  "./logo.png": "64423",
  "./low.png": "12339",
  "./medium.png": "21378",
  "./signature.png": "74886",
  "./waiting.png": "48360",
  "./yaago.png": "56152"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84437;
